import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { passiveAgreement } from "../../slices/apps/agreementSlice";

// data dosyaları
import Question from "../../assets/images/question.png";

const AgreementPassiveModal = ({ id, isActive, isOpen, toggle }) => {
  const dispatch = useDispatch();

  // states
  const { passiveAgreementLoading } = useSelector((state) => {
    return {
      passiveAgreementLoading: state.agreement.passiveAgreementLoading,
    };
  }, shallowEqual);

  const setPassiveAgreement = async () => {
    const data = {
      agreementId: id,
      isActive: !isActive,
    };

    try {
      const resultAction = await dispatch(passiveAgreement(data));

      if (resultAction.meta.requestStatus === "fulfilled") {
        toggle();
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className="modal-title "
        id="myLargeModalLabel"
        toggle={toggle}
      >
        Sözleşmeyi {isActive ? "Pasifleştir" : "Aktifleştir"}
      </ModalHeader>

      <ModalBody className="text-center text-dark">
        <img
          src={Question}
          alt="SMS Question"
          id="candidate-img"
          className="img-fluid mb-4"
          style={{ height: "80px" }}
        />
        <h4 className="text-dark">
          Bu sözleşmeyi {isActive ? "pasifleştirmek" : "aktifleştirmek"}{" "}
          istediğinize emin misiniz?
        </h4>
        <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
          <Button
            className="btn btn-sm"
            color="primary"
            disabled={passiveAgreementLoading}
            onClick={setPassiveAgreement}
          >
            Onayla
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AgreementPassiveModal;
